import "@janeapp/burrito-design-system/fonts.css"
import "@janeapp/burrito-design-system/globalTheme"
import { BurritoProvider } from "@janeapp/burrito-design-system"
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import reportWebVitals from './reportWebVitals'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <BurritoProvider>
      <App />
    </BurritoProvider>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
